import styles from "./SplitColumns.module.scss";

/**
 * Two side-by-side panels, each with its OWN heading and body (Figma 5594-8214
 * "Organic and Natural…" / "Logistics and Bulk…"). Distinct from `richText`,
 * which has one heading spanning columns of continuous prose.
 *
 * Each column's `body` is an array of blocks:
 *   - a string            → a paragraph
 *   - { list: [...] }     → a bulleted list
 *   - { text, list }      → an intro line followed by its bulleted list
 *
 * Panels sit on a grey surface separated by a thin gap of the page background
 * (that gap IS the divider in Figma — there is no drawn rule). Column count is
 * `columns.length`, so a 3-up variant needs no code change.
 */
function renderBlock(block, i) {
  if (typeof block === "string") {
    return (
      <p className={styles.para} key={i}>
        {block}
      </p>
    );
  }

  const { text, list } = block || {};
  return (
    <div className={styles.listBlock} key={i}>
      {text && <p className={styles.para}>{text}</p>}
      {list?.length > 0 && (
        <ul className={styles.list}>
          {list.map((li, j) => (
            <li className={styles.listItem} key={j}>
              {li}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default function SplitColumns({ columns = [], surface = "grey" }) {
  if (!columns.length) return null;

  return (
    <section className={`${styles.section} ${styles[surface]}`}>
      <div className={styles.inner}>
        {columns.map((col, i) => {
          const blocks = Array.isArray(col.body)
            ? col.body
            : col.body
              ? [col.body]
              : [];
          return (
            <div className={styles.panel} key={i}>
              {col.heading && (
                <h2 className={styles.heading}>{col.heading}</h2>
              )}
              {blocks.map(renderBlock)}
            </div>
          );
        })}
      </div>
    </section>
  );
}
